import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const SliderArrowLeftContainer = styled.div<React.CSSProperties>`
  background: rgba(0, 0, 0, 0.8);
  border-radius: 0 ${Screen.widthRatio * 30}px ${Screen.widthRatio * 30}px 0;
  display: flex;
  height: ${Screen.widthRatio * 430}px;
  flex-direction: column;
  justify-content: center;
  line-height: ${Screen.widthRatio * 480}px;
  opacity: 0;
  padding-left: ${Screen.widthRatio * 29}px;
  position: absolute;
  top: ${Screen.widthRatio * 5}px;
  width: ${Screen.widthRatio * 129}px;
  &:hover {
    opacity: 1;
  }
`;

export default withAnimation(SliderArrowLeftContainer);
